import { $generateHtmlFromNodes } from "@lexical/html";

export default function jsonToHtml(editorRef) {
    const wrapper = editorRef.current;
    if (!wrapper || !wrapper.editor) return "";

    const editor = wrapper.editor;
    let html = "";
    const editorState = editor.getEditorState();

    editorState.read(() => {
        html = $generateHtmlFromNodes(editor, null);
    });

    return html;
}
